import Api from 'services/api'
import { Annotation } from 'types/building'

import {
  CopyAnnotationPayload,
  DeleteAnnotationPayload,
  SaveAnnotationPayload
} from './types'

export const annotationRepository = {
  getAnnotation: async (id: string | number): Promise<Annotation> => {
    return Api.get<Annotation>(`/v1/annotations/${id}`)
  },

  saveAnnotation: async (
    payload: SaveAnnotationPayload,
    pointVersionIdOrOptions?:
      | number
      | { pointVersionId?: number; headers?: Record<string, string> }
  ): Promise<{ data: Annotation }> => {
    const pointVersionId =
      typeof pointVersionIdOrOptions === 'number'
        ? pointVersionIdOrOptions
        : pointVersionIdOrOptions?.pointVersionId
    const extraHeaders =
      typeof pointVersionIdOrOptions === 'object'
        ? pointVersionIdOrOptions.headers
        : undefined

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...(extraHeaders || {})
    }
    if (pointVersionId != null) {
      headers['X-Point-Version-ID'] = String(pointVersionId)
    }
    return Api.put<SaveAnnotationPayload>(
      '/v1/annotations',
      payload,
      headers as any
    )
  },

  deleteAnnotation: async (payload: DeleteAnnotationPayload | string) => {
    if (typeof payload === 'string') {
      return Api.delete(`/v1/annotations/${payload}`, {})
    }
    const { annotation_id: annotationId, ...queryParams } = payload
    const query = new URLSearchParams(
      Object.entries(queryParams)
        .filter(([, v]) => v !== undefined && v !== null && v !== '')
        .map(([k, v]) => [k, String(v)])
    ).toString()

    return Api.delete(
      `/v1/annotations/${annotationId}${query ? `?${query}` : ''}`,
      {}
    )
  },

  copyAnnotation: async (payload: CopyAnnotationPayload) => {
    return Api.post('/v1/annotations/copy-annotation', payload)
  }
}

export default annotationRepository
